/**
 * Site Configuration
 * All values are read from environment variables for easy customization
 */

export const siteConfig = {
  // Basic site info
  name: process.env.NEXT_PUBLIC_SITE_NAME || "Universitas Mulawarman",
  nameEnglish: process.env.NEXT_PUBLIC_SITE_NAME_ENGLISH || "Mulawarman University",
  title:
    process.env.NEXT_PUBLIC_SITE_TITLE ||
    "Universitas Mulawarman - Tropical Studies Center",
  description:
    process.env.NEXT_PUBLIC_SITE_DESCRIPTION ||
    "Universitas Mulawarman, Pusat Studi Tropis terdepan yang bersinergi dengan pembangunan Ibu Kota Negara (IKN) untuk masa depan Indonesia.",
  keywords: (
    process.env.NEXT_PUBLIC_SITE_KEYWORDS ||
    "Universitas Mulawarman,UNMUL,Perguruan Tinggi,Samarinda,Kalimantan Timur,IKN,Tropical Studies"
  ).split(","),

  // Web Type: 0=UNMUL, 1=FAKULTAS, 2=PRODI, 3=UNIT
  webType: process.env.NEXT_PUBLIC_WEB_TYPE || "0",

  // URLs
  url: process.env.NEXT_PUBLIC_SITE_URL || "https://unmul.ac.id",
  origin: process.env.NEXT_PUBLIC_ORIGIN || "https://unmul.ac.id",

  // Locale
  locale: process.env.NEXT_PUBLIC_SITE_LOCALE || "id_ID",

  // Branding
  logo: "/logo.png",

  // Social/OG defaults
  ogImage: "/logo.png",
  ogImageWidth: 1200,
  ogImageHeight: 630,

  // Contact Info
  contact: {
    address:
      process.env.NEXT_PUBLIC_CONTACT_ADDRESS ||
      "Jl. Kuaro, Gn. Kelua, Kec. Samarinda Ulu, Kota Samarinda, Kalimantan Timur 75119",
    phone: process.env.NEXT_PUBLIC_CONTACT_PHONE || "(0541) 749343",
    email: process.env.NEXT_PUBLIC_CONTACT_EMAIL || "humas@unmul.ac.id",
    workingHours:
      process.env.NEXT_PUBLIC_CONTACT_HOURS || "Senin - Jumat: 08:00 - 16:00",
  },

  // Social Media
  socials: {
    facebook:
      process.env.NEXT_PUBLIC_SOCIAL_FACEBOOK || "https://facebook.com/unmul",
    instagram:
      process.env.NEXT_PUBLIC_SOCIAL_INSTAGRAM || "https://instagram.com/unmul",
    twitter:
      process.env.NEXT_PUBLIC_SOCIAL_TWITTER || "https://twitter.com/unmul",
    youtube:
      process.env.NEXT_PUBLIC_SOCIAL_YOUTUBE || "https://youtube.com/unmul",
    linkedin:
      process.env.NEXT_PUBLIC_SOCIAL_LINKEDIN ||
      "https://linkedin.com/school/universitas-mulawarman",
    tiktok:
      process.env.NEXT_PUBLIC_SOCIAL_TIKTOK || "https://tiktok.com/@unmul",
  },

  // API
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "https://api-gateway.unmul.ac.id",
  // unitId is now dynamic, fetched via API based on APP_GROUP
  // unitId: process.env.NEXT_PUBLIC_UNIT_ID || "1",
} as const;

export type SiteConfig = typeof siteConfig;
